// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__Zj7U4"};